export const candidateTabSuggested = 'Suggested';
export const candidateTabInterested = 'Interested';
export const candidateTabShortlisted = 'Shortlisted';
export const candidateTabApproved = 'Approved';
export const candidateTabHired = 'Hired';
export const candidateTabRejected = 'Rejected';

export const candidateTabs = [
    candidateTabSuggested,
    candidateTabInterested,
    candidateTabShortlisted,
    candidateTabApproved,
    candidateTabHired,
    candidateTabRejected,
];